var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import MenuMUI from '@mui/material/Menu';
import MenuItemMUI from '@mui/material/MenuItem';
import clsx from 'clsx';
import styles from './menu.module.css';
export const Menu = (_a) => {
    var { items, children, noSpacing, classes } = _a, restProps = __rest(_a, ["items", "children", "noSpacing", "classes"]);
    const [id] = useState(new Date().getTime() + Math.random());
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleItemClick = (item) => {
        var _a;
        (_a = item.onClick) === null || _a === void 0 ? void 0 : _a.call(item);
        handleClose();
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { id: `menu-trigger-${id}`, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, onClick: handleClick, className: clsx(styles.trigger, {
                    [styles.withoutSpacing]: !noSpacing,
                }), children: children }), _jsx(MenuMUI, Object.assign({ id: `menu-trigger-${id}`, MenuListProps: {
                    'aria-labelledby': `menu-trigger-${id}`,
                }, classes: {
                    root: clsx(styles.menu, classes === null || classes === void 0 ? void 0 : classes.root),
                }, anchorEl: anchorEl, onClose: handleClose, disableAutoFocusItem: true }, restProps, { open: open, children: items.map((item) => (_jsxs(MenuItemMUI, { onClick: () => handleItemClick(item), "data-testid": "menu-item", children: [item.icon && (_jsx("span", { className: clsx(styles.icon, 'menu-icon'), children: item.icon })), ' ', item.label] }, item.label))) }))] }));
};
